<template>
    <q-page class="q-pa-md full-height">
        <q-card class="q-pa-md q-mt-md full-height" style="max-height: calc(100vh - 120px);">
            <div class="row q-col-gutter-md full-height">
                <!-- Menú lateral -->
                <div class="col-3 full-height" style="border-right: 1px solid #E2E2E2;">
                    <div class="row q-col-gutter-md">
                        <div class="col-12 text-center">
                            <div class="relative-position inline-block">
                                <q-avatar size="200px">
                                    <img :src="imagenPerfil" />
                                </q-avatar>

                                <!-- Ícono de editar -->
                                <q-btn icon="mdi-pencil" color="primary" size="md" round
                                    class="absolute-bottom-right q-mb-xs q-mr-xs" @click="seleccionarFoto" />

                                <!-- Selector de archivo oculto -->
                                <input ref="fileInput" type="file" accept="image/*" style="display: none"
                                    @change="cambiarFoto" />
                            </div>
                        </div>
                        <!-- <div class="col-12 text-center">
                            <q-avatar size="200px">
                                <img src="https://cdn.quasar.dev/img/boy-avatar.png">
                            </q-avatar>
                        </div> -->

                        <div class="col-12">
                            <q-list class="text-primary q-pa-md">
                                <q-item clickable v-ripple :active="link === 'perfil'" @click="link = 'perfil'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="person" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Mi Perfil
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'empresa'" @click="link = 'empresa'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="business" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Datos de la Empresa
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'fiscal'" @click="link = 'fiscal'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="description" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Datos Fiscales
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'domicilio'" @click="link = 'domicilio'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="home" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Domicilio Fiscal
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'bancarios'" @click="link = 'bancarios'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="account_balance" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Datos Bancarios
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'certificado'"
                                    @click="link = 'certificado'" active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="vpn_key" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Certificado Digital
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-ripple :active="link === 'usuarios'" @click="link = 'usuarios'"
                                    active-class="my-menu-link" class="rounded-borders">
                                    <q-item-section avatar>
                                        <q-icon name="group" class="class-menu-icono" />
                                    </q-item-section>
                                    <q-item-section>
                                        Usuarios del Sistema
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                    </div>
                </div>

                <!-- Contenido -->
                <div class="col-9 q-pa-xl" style="height: 100%; overflow-y: auto;">
                    <component :is="link === 'perfil' ? 'PerfilUsuario' : null" />
                    <component :is="link === 'empresa' ? 'DatosEmpresa' : null" />
                    <component :is="link === 'fiscal' ? 'DatosFiscales' : null" />
                    <component :is="link === 'domicilio' ? 'DomicilioFiscal' : null" />
                    <component :is="link === 'bancarios' ? 'DatosBancarios' : null" />
                    <component :is="link === 'certificado' ? 'CertificadoDigital' : null" />
                    <component :is="link === 'usuarios' ? 'UsuariosSistema' : null" />
                </div>
            </div>
        </q-card>
    </q-page>
</template>

<script>
import { QSpinnerClock } from 'quasar'
import axios from 'axios'

import PerfilUsuario from './MiPerfil.vue'
import DatosEmpresa from './DatosEmpresa.vue'
import DatosFiscales from './DatosFiscales.vue'
import DomicilioFiscal from './DomicilioFiscal.vue'
import DatosBancarios from './DatosBancarios.vue'
import CertificadoDigital from './CertificadoDigital.vue'
import UsuariosSistema from './UsuariosSistema.vue'

export default {
    components: {
        PerfilUsuario,
        DatosEmpresa,
        DatosFiscales,
        DomicilioFiscal,
        DatosBancarios,
        CertificadoDigital,
        UsuariosSistema
    },
    data() {
        return {
            link: 'perfil',
            hover: false,
            imagenPerfil: ''
        }
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    methods: {
        seleccionarFoto() {
            this.$refs.fileInput.click()
        },
        cambiarFoto(e) {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })

            const file = e.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = async (event) => {
                    const base64Image = event.target.result
                    this.imagenPerfil = base64Image

                    try {
                        await axios.post('Configuracion/GuardarFotoPerfil', {
                            idUsuario: this.adminStore._id,
                            imagenBase64: base64Image
                        })
                        this.$q.loading.hide()
                        this.obtenerPerfil()
                        this.$q.notify({ type: 'positive', position: 'top-right', message: 'Foto de perfil actualizada' })
                    } catch (err) {
                        this.$q.loading.hide()

                        this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al guardar la foto' })
                    }
                }
                reader.readAsDataURL(file)
            }
        },

        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetFotoUsuarioPorId/' + this.adminStore._id)
                this.imagenPerfil = res.data
                this.$store.state.auth.usuario.fotoPerfilBase64 = res.data

            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        }
    },
    mounted() {
        this.obtenerPerfil()
    },
}
</script>

<style scoped>
.class-menu-icono {
    color: #697A8D;
}

.my-menu-link {
    color: white;
    background: #0094CA;
}

.my-menu-link i {
    color: white;
}
</style>